import { NcaLink, Section, Table } from 'nca-acquiring-theme';
import { TransactionSearchSupportedFieldsTable } from "../../../../src/snippets/transaction-search-table";
import * as React from 'react';
export default {
  NcaLink,
  Section,
  Table,
  TransactionSearchSupportedFieldsTable,
  React
};